<style lang="stylus">
    .Loading
        modal-mask()
        .loading-ring
            position absolute
            left 0
            right 0
            top 0
            bottom 0
            margin auto
            padding 12px 16px
            width fit-content
            height 48px
            display flex
            justify-content center
            align-items center
            background: var(--border-color-tips);
            border: 0.5px solid rgba(0, 0, 0, 0.05);
            /* Note: backdrop-filter has minimal browser support */
            backdrop-filter: blur(2px);
            border-radius: 8px;
            svg
                animation ani-load-loop 0.8s linear infinite
            .loading-text
                color white
                margin-left 8px
        .process-box
            position absolute
            width 230px
            height 80px
            top 0
            right 0
            bottom 0
            left 0
            margin auto
            background-color #fff
            border-radius 3px
            box-shadow $box-shadow
            .process-bar
                width 80%
                height 20px
                display flex
                justify-content space-around
                margin 0 auto
                margin-top 15px
                .process
                    width 130px
                    height 5px
                    background-color #eee
                    border-radius 15px
                    margin-top 7px
                    .process-inner
                        height 5px
                        border-radius 15px
                        background-color var(--themeColor)
                .process-number
                    font-size 12px
                    color var(--themeColor)
            .process-loading
                margin-top 5px
                p
                    font-size 14px
                    text-align center
                    color #333
                    display flex
                    flex-wrap wrap
                    justify-content center
                    &::after
                        content '...'
                        display block
                        text-align left
                        width 13px
                        font-size 16px
                        color #333
                        animation loading 2s infinite
    @keyframes loading
        0%
            content '.  '
        50%
            content '.. '
        100%
            content '...'
</style>

<template>
    <div class="Loading">
        <!-- 旋转加载 -->
        <div v-if="loadType == 'rotate'" class="loading-ring">
            <svg id="loader-1" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_2292_53134)">
                    <path
                        opacity="0.2"
                        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                        stroke="white"
                        stroke-width="2.5"
                    />
                    <path d="M22 12C22 6.47715 17.5228 2 12 2" stroke="white" stroke-width="2.5" stroke-linecap="round" />
                </g>
                <defs>
                    <clipPath id="clip0_2292_53134"><rect width="24" height="24" fill="white" /></clipPath>
                </defs>
            </svg>
            <p class="loading-text">{{ $t(loadingText) }}</p>
        </div>
        <!-- 进度条加载 -->
        <div v-if="loadType == 'process'" class="process-box">
            <div class="process-bar">
                <div class="process">
                    <div :style="{ width: `${130 * process}px` }" class="process-inner"></div>
                </div>
                <p class="process-number">{{ `${Math.round(process * 100)}%` }}</p>
            </div>
            <div class="process-loading">
                <p>{{ $t(loadingText) }}</p>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";

    @Component({
        components: {},
    })
    export default class Loading extends Vue {
        // 旋转（rotate）加载和进度条（process）加载
        @Prop({ default: "rotate" }) loadType: string;

        get process() {
            return this.$store.state.ui.LoadingProcess;
        }
        get loadingText() {
            return this.$store.state.ui.loadingTextType || this.$t("library");
        }
        mounted() {}

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "library": "加载中",
    "map": "正在为您加载地图数据"
  },
  "en": {
    "library": "Loading",
    "map": "Loading Map for You"
  },
  "de": {
    "library": "Beladen ",
    "map": "Lädt die Karte für Sie"
  },
  "jp": {
    "library": "読み込み中",
    "map": "地図データを読み込んでいます"
  },
  "fr": {
    "library": "Chargement en cours",
    "map": "Chargement de la carte pour vous"
  },
  "es": {
    "library": "Cargando",
    "map": "Cargando el mapa para ti"
  },
  "pt": {
    "library": "Carregando",
    "map": "Carregando Mapa para Si"
  },
  "it": {
    "library": "Caricamento in corso",
    "map": "Caricamento della Mappa in Corso"
  },
  "tw": {
    "library": "正在為您加載",
    "map": "正在為您加載地圖數據"
  },
  "kr": {
    "library": "로드 중",
    "map": "맵 로드 중"
  }
}
</i18n>
